import {AxiosError} from 'axios';
import tryToCatch from 'try-to-catch';
import {curry} from 'ramda';

import {DispatchAny} from '@pluto/@types';
import {
    getImportMediaOrder,
    formQuery,
} from '@pluto/rest';
import {setNotificationAction} from '@pluto/notification';
import {baseRoutes} from 'App/AppRouter/routes';
import {setMediaOrdersListAction} from '../../MediaOrdersList/Redux/MediaOrdersListActions';
import {
    MediaOrderValidationItem,
    ImportMediaOrderActionParams,
    ImportErrorParams,
    ImportSuccessParams,
} from '../../MediaOrdersTypes';

export const MEDIA_ORDER_IMPORT = 'MEDIA_ORDER_IMPORT';

export const mapIds = (error: MediaOrderValidationItem, id: number) => ({
    ...error,
    id,
});

export const importError = (params: ImportErrorParams, dispatch: DispatchAny) => {
    const {
        errorData,
        setValidations,
        setValidationsVisible,
    } = params;
    const {
        errors,
        message,
    } = errorData;
    const [firstError] = errors;
    
    setValidations(errors.map(mapIds));
    setValidationsVisible(true);
    
    if (firstError.message === 'media_order_id must be unique') {
        return dispatch(setNotificationAction({
            type: 'error',
            text: 'IMPORT FAILURE: Media Order already exists.',
        }));
    }
    
    return dispatch(setNotificationAction({
        type: 'error',
        text: message,
    }));
};

export const successfulImport = (params: ImportSuccessParams, dispatch: DispatchAny) => {
    const {
        setFilter,
        history,
        handleClose,
        listRowsPerPage,
        setMediaOrderId,
    } = params;
    
    const queryParams = {
        limit: listRowsPerPage,
        offset: 0,
    };
    
    dispatch(setMediaOrdersListAction(queryParams));
    setMediaOrderId('');
    setFilter({
        contentPartnerId: '',
        labPartner: '',
    });
    history.push({
        pathname: baseRoutes.mediaOrders,
        search: formQuery('', queryParams),
    });
    handleClose();
    
    return dispatch(setNotificationAction({
        type: 'success',
        text: 'Media Order imported successfully',
    }));
};

export const importMediaOrderAction = curry(async (params: ImportMediaOrderActionParams, dispatch: DispatchAny) => {
    const {
        formData,
        setValidations,
        setValidationsVisible,
        handleClose,
        setFilter,
        history,
        listRowsPerPage,
        setMediaOrderId,
    } = params;
    
    const [error] = await tryToCatch(getImportMediaOrder, formData);
    
    if (!error)
        return successfulImport({
            setFilter,
            history,
            handleClose,
            listRowsPerPage,
            setMediaOrderId,
        }, dispatch);
    
    const {response} = error as AxiosError;
    
    if (response?.data.code === 'EVALIDATION') {
        return importError({
            errorData: response.data,
            setValidations,
            setValidationsVisible,
        }, dispatch);
    }
    
    return dispatch(setNotificationAction({
        type: 'error',
        text: 'Error occurred while importing Media Order.',
    }));
});
